import React from 'react';
import PropTypes from 'prop-types';
import styles from '../sass/AdminHeader.module.scss';

const AdminMenu = ({ menuButtons }) => {
  return (
    <div className={styles.menuContainer}>
      {menuButtons.map(({
        label, onClick, icon, iconHover
      }) => (
        <button
          key={label}
          className={styles.menuContainerItem}
          onClick={onClick}
        >
          <img src={icon} alt={label} />
          <img src={iconHover} className={styles.imageHover} alt={label} />
        </button>
      ))}
    </div>
  );
};

AdminMenu.propTypes = {
  menuButtons: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func,
    icon: PropTypes.string,
    iconHover: PropTypes.string
  })).isRequired
};

export default AdminMenu;
